import { CommandBarButton, IButtonProps, IconButton } from "@fluentui/react";
import * as React from "react";

import { TooltipHost } from "../../surfaces/tooltip/TooltipHost";

export type DeleteButtonProps = Pick<IButtonProps, "id" | "disabled" | "onClick" | "styles"> & {
    isLabeled?: boolean;
    label?: string;
};

export const DeleteButton: React.FunctionComponent<DeleteButtonProps> = (props: DeleteButtonProps) => {
    const label = props.label || "Delete";

    return (
        <>
            {props.isLabeled ? (
                <CommandBarButton
                    key={props.id}
                    iconProps={{ iconName: "Delete" }}
                    disabled={props.disabled}
                    onClick={props.onClick}
                    allowDisabledFocus={false}
                    checked={false}
                    ariaLabel={label}
                    text={label}
                    styles={props.styles}
                />
            ) : (
                <TooltipHost content={label} styles={{ root: { display: "inline-block" } }}>
                    <IconButton
                        key={props.id}
                        iconProps={{ iconName: "Delete" }} // or EditSolid12
                        disabled={props.disabled}
                        onClick={props.onClick}
                        allowDisabledFocus={false}
                        checked={false}
                        ariaLabel={label}
                        styles={props.styles}
                    />
                </TooltipHost>
            )}
        </>
    );
};
